import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleDown } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import { ArrowUpDown } from "../../icons/SvgIcons";

// Wrapper for the whole dropdown component
const DropdownWrapper = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  position: relative;
`;

// Main button container (left + center + right)
const DropDownContainer = styled.div`
  display: flex;
  width: 100%;
  height: 30px;
  border-radius: ${(props) => (props.isRadius ? "5px" : "0px")};
  overflow: hidden;
`;

const DropDownLeft = styled.div`
  width: 30px;
  background-color: #99b0ad;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const DropDownButtonLeft = styled.div`
  flex: 1;
  padding: 0 6px;
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: bold;
  color: #99b0ad;
  background-color: ${(props) => (props.isPeopleAndZero ? "#EE754C" : "white")};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
`;

const DropDownButtonRight = styled.div`
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: white;
`;

// Dropdown menu list
const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 100;
  width: 100%;
  background-color: white;
  border-radius: 0 0 5px 5px;
  max-height: 200px;
  overflow-y: auto;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

// Individual item
const DropdownMenuItem = styled.div`
  padding: 6px 12px;
  font-size: 13px;
  color: #333;
  cursor: pointer;
  background-color: ${(props) => (props.selected ? "#f0f0f0" : "white")};

  &:hover {
    background-color: #e0e0e0;
  }
`;

function DropdownSortItems({
  options,
  handleOptionChange,
  initialOption,
  isPeople = false,
  update,
  setUpdate = false,
  isRadius = true,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(initialOption);
  const selectedRef = useRef(null);

  useEffect(() => {
    setSelectedOption(initialOption);
  }, [initialOption]);

  useEffect(() => {
    if (isOpen && selectedRef.current) {
      selectedRef.current.scrollIntoView({ block: "center" });
    }
  }, [isOpen]);

  const handleSelect = (option, e) => {
    e.preventDefault();
    setSelectedOption(option);
    handleOptionChange(option);
    setIsOpen(false);
    if (setUpdate) setUpdate(update + 1);
  };

  const handleOpen = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  return (
    <DropdownWrapper onClick={handleOpen}>
      <DropDownContainer isRadius={isRadius}>
        <DropDownLeft>
          <ArrowUpDown width={18} height={18} strokeColor={"#FAF6E9"} />
        </DropDownLeft>

        <DropDownButtonLeft isPeopleAndZero={isPeople && selectedOption === 0}>
          {isPeople && selectedOption === 0 ? "nº Pessoas" : selectedOption}
        </DropDownButtonLeft>

        <DropDownButtonRight>
          <div className={`arrow-icon ${isOpen ? "rotate-menu-arrow" : ""}`}>
            <FontAwesomeIcon
              icon={faChevronCircleDown}
              size="lg"
              color="#99B0AD"
            />
          </div>
        </DropDownButtonRight>
      </DropDownContainer>

      {isOpen && (
        <DropdownMenu>
          {options.map((option, index) => (
            <DropdownMenuItem
              key={index}
              selected={option === selectedOption}
              onClick={(e) => handleSelect(option, e)}
              ref={option === selectedOption ? selectedRef : null}
            >
              {option}
            </DropdownMenuItem>
          ))}
        </DropdownMenu>
      )}
    </DropdownWrapper>
  );
}

export default DropdownSortItems;
